var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-2 text-2xl p-4 md:p-8 font-semibold rounded-lg hover:bg-white hover:text-gray-800 transition ease-in-out duration-150 select-none cursor-pointer",class:[_vm.textClass, _vm.borderClass],on:{"click":_vm.emitClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }